import { motion, useScroll, useSpring } from "framer-motion";

export default function ScrollProgress() {
    const { scrollYProgress } = useScroll();
    const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 24, mass: 0.4 });
    return (
        <motion.div
            style={{ scaleX }}
            className="fixed inset-x-0 top-0 z-[70] h-[2.5px] origin-left bg-brand-red"
            data-testid="scroll-progress-bar"
            aria-hidden="true"
        />
    );
}
